<template>
  <callout
    apply-border-top
    :border-color="
      getAppointmentStatusColor(value.statusId != null ? value.statusId : 0)
    "
    :controlled="true"
    :has-toggle="true"
    :opened="value.isOpen"
    @click:open="showDetail"
  >
    <div class="row">
      <div class="col-sm-12 col-md-8 d-flex py-3 pr-5 align-items-center">
        <div class="c-pictureProfile">
          <em class="fas fa-user-alt fa-stack-1x fa-inverse" />
        </div>
        <span class="color-black font-weight-bold font-18 ml-3">
          {{ value.specialistNumber }}
        </span>
        <span class="color-black font-weight-normal font-16 ml-4">
          {{ value.specialistName }}
        </span>
      </div>
      <div
        class="flex-grow-1 d-flex text-right col-12  col-md-4 align-items-center justify-content-end"
      >
        <action-button
          class="actionButton"
          i="fa fa-plus-circle"
          variant="outline-success"
          @click="$emit('create-space', value)"
        >
          Crear Espacios Disponibles
        </action-button>
      </div>
    </div>
    <template #edition>
      <div class="fiscal-calendar-container mt-2">
        <fiscal-calendar
          class="fiscal-calendar"
          :year="value.fiscalYearName"
          @on-datarange-changed="onDetailDatarangeChanged"
        >
          <template #filters />
          <template #details>
            <div class="clearfix" />
            <div class="col-sm-12">
              <div
                v-for="(rowItem, rowIndex) in page.data"
                :key="`row-item-${rowIndex}`"
                class="mt-2 c-cardContainer"
              >
                <callout
                  :border-color="
                    getAppointmentStatusColor(
                      rowItem.statusId != null ? rowItem.statusId : 0
                    )
                  "
                  :has-toggle="true"
                >
                  <div class="row c-cardContent">
                    <div
                      class="col-lg-2 col-12 d-flex py-3 align-items-center bg-secondary-9"
                    >
                      <span
                        class="font-weight-bold font-16 text-center w-100 startDate"
                      >
                        {{ rowItem.startDate | daywithnumber }}
                      </span>
                    </div>

                    <div class="row m-0 p-3 p-md-0 col">
                      <div class="col-6 col-md my-1 bg-white order-1">
                        <div class="mt-1 serviceTypeName_title">
                          {{ rowItem.evaluationTypeName }}
                        </div>
                        <span
                          class="color-black font-weight-normal font-16 serviceTypeName_value"
                        >
                          {{ rowItem.serviceName }}
                        </span>
                      </div>
                      <div
                        class="col-12 col-md my-1 bg-white order-3 order-md-2"
                      >
                        <div class="mt-1 schedule_title">
                          Horario:
                        </div>
                        <span
                          class="color-black font-weight-normal font-16 schedule_value"
                        >
                          {{ rowItem.startTime }} - {{ rowItem.endTime }}
                        </span>
                      </div>
                      <div
                        class="col-12 col-md my-1 bg-white col-status order-3"
                      >
                        <div
                          class="color-black font-weight-bold font-16 mt-1 estatus_title"
                        >
                          Estatus:
                        </div>
                        <div
                          class="color-black font-16 d-flex align-item-center"
                        >
                          <em
                            class="fa fa-circle font-12"
                            :class="
                              `color-${getAppointmentStatusColor(
                                rowItem.statusId != null ? rowItem.statusId : 0
                              )}`
                            "
                          />
                          <span
                            class="color-black font-weight-normal font-16 ml-2 estatus_value"
                          >
                            {{
                              rowItem.statusName != null
                                ? rowItem.statusName
                                : 'Disponible'
                            }}
                          </span>
                        </div>
                      </div>
                      <div
                        class="col-6 col-md d-flex justify-content-end align-items-center bg-white my-1 pt-3 mr-md-4 mr-0  order-2 order-md-4"
                      >
                        <action-button
                          v-if="!rowItem.isCoordinated"
                          i="fa fa-edit"
                          variant="outline-success pr-0 mt-n3"
                          @click="$emit('edit-space', value, rowItem)"
                        />
                        <action-button
                          v-if="!rowItem.isCoordinated"
                          i="fa fa-times-circle"
                          variant="outline-danger pr-0 ml-2 mt-n3"
                          @click="
                            $emit(
                              'delete-space',
                              rowItem.clientAppointmentSpaceID,
                              index
                            )
                          "
                        />
                      </div>
                    </div>
                  </div>
                  <template #edition>
                    <div class="appointment-detail">
                      <div
                        v-if="rowItem.statusId != null"
                        class="row header-row"
                      >
                        <div class="col">
                          <em class="fas fa-info-circle color-orange mr-2" />
                          <span class="color-gray-7 font-weight-bold font-16">
                            Información del Estudiante
                          </span>
                        </div>
                      </div>
                      <div v-if="rowItem.statusId != null" class="row data-row">
                        <div class="col-md-4">
                          <div
                            class="color-secondary-6 font-weight-normal font-14"
                          >
                            Estudiante:
                          </div>
                          <span class="color-black font-weight-normal font-16">
                            {{ rowItem.student }}
                          </span>
                        </div>
                        <div class="col-md-4">
                          <div
                            class="color-secondary-6 font-weight-normal font-14"
                          >
                            Contacto:
                          </div>
                          <span class="color-black font-weight-normal font-16">
                            {{ rowItem.contactInformation.fullName }}
                          </span>
                          <div class="clearfix" />
                          <span class="color-black font-weight-normal font-16">
                            {{
                              rowItem.contactInformation.telephoneHomeNo | phone
                            }}
                          </span>
                          <div class="clearfix" />
                          <span class="color-black font-weight-normal font-16">
                            {{ rowItem.contactInformation.email | email }}
                          </span>
                        </div>
                        <div class="col-md-4">
                          <div
                            class="color-secondary-6 font-weight-normal font-14"
                          >
                            Dirección:
                          </div>
                          <span class="color-black font-weight-normal font-16">
                            {{ rowItem.studentAddress1
                            }}{{
                              rowItem.studentAddress2
                                ? `, ${rowItem.studentAddress2}`
                                : ''
                            }}
                          </span>
                        </div>
                        <div class="col-md-12 mt-3">
                          <div
                            class="color-secondary-6 font-weight-normal font-14"
                          >
                            Escuela:
                          </div>
                          <span class="color-black font-weight-normal font-16">
                            {{
                              rowItem.studentSchoolName
                                ? rowItem.studentSchoolName
                                : '-'
                            }}
                          </span>
                        </div>
                      </div>
                      <div class="row header-row">
                        <div class="col">
                          <em class="fas fa-info-circle color-orange mr-2" />
                          <span class="color-gray-7 font-weight-bold font-14">
                            Información Adicional
                          </span>
                        </div>
                      </div>
                      <div class="row data-row no-gutters">
                        <div class="col-md-4 additionalInfo_item">
                          <div
                            class="color-secondary-6 font-weight-normal font-14"
                          >
                            Proveedor:
                          </div>
                          <span
                            class="color-black font-weight-normal font-16 additionalInfo_value"
                          >
                            {{ rowItem.companyName }}
                          </span>
                        </div>
                        <div class="col-md-3 additionalInfo_item">
                          <div
                            class="color-secondary-6 font-weight-normal font-14"
                          >
                            Municipio:
                          </div>
                          <span
                            class="color-black font-weight-normal font-16 additionalInfo_value"
                          >
                            {{ rowItem.locationMunicipalityName }}
                          </span>
                        </div>
                        <div class="col-md-4 additionalInfo_item">
                          <div
                            class="color-secondary-6 font-weight-normal font-14"
                          >
                            Lugar de Servicio:
                          </div>
                          <span
                            class="color-black font-weight-normal font-16 additionalInfo_value"
                          >
                            {{ rowItem.locationName }}
                          </span>
                        </div>
                        <div
                          v-if="rowItem.reasonDescription !== null"
                          class="col-md-12 mt-3 additionalInfo_item"
                        >
                          <div
                            class="color-secondary-6 font-weight-normal font-14"
                          >
                            Razón de Referido:
                          </div>
                          <span
                            class="color-black font-weight-normal font-16 additionalInfo_value"
                          >
                            {{ rowItem.reasonDescription }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                </callout>
              </div>
              <div class="detail-no-data">
                <not-available-space
                  v-if="page.data.length === 0"
                  class="mt-2"
                  message="No existen espacios disponibles."
                />
              </div>

              <pagination
                v-if="page.totalItemCount > 5"
                :data="page"
                @pagination-go-page="setCurrentPage"
              />
            </div>
          </template>
        </fiscal-calendar>
      </div>
    </template>
  </callout>
</template>

<script>
import Pagination from '@/components/common/Pagination';

import statusColorMixin from '@/mixins/shared/appointmentStatusColor';
import alert from '@/mixins/alert.mixin';
import { NotAvailableSpace } from './components';

import moment from 'moment';

import { FiscalCalendar } from '@/shared/components/FiscalCalendar';
import Callout from 'custom-callout';
import storeMixin from 'utils/mixins/storeGenerator';

export default {
  name: 'AvailableSpaceRow',
  components: {
    NotAvailableSpace,
    FiscalCalendar,
    Pagination,
    Callout,
  },
  mixins: [alert, statusColorMixin, storeMixin],
  props: {
    index: {
      type: Number,
      default: () => 0,
    },
    value: {
      type: Object,
      default: () => {
        return {
          specialistName: null,
          specialistNumber: null,
          currentPeriod: null,
          isOpen: false,
          appointmentDetails: [],
        };
      },
    },
  },
  data() {
    return {
      page: {
        totalItemCount: 0,
        count: 5,
        pageCount: 0,
        currentPage: 1,
        data: null,
      },
      dateRangeFilter: {
        startDate: new Date(),
        endDate: moment(new Date())
          .add(1, 'day')
          .toDate(),
        month: 0,
        week: 0,
        day: 0,
      },
    };
  },
  computed: {
    pageData() {
      return null;
    },
  },
  watch: {
    value() {
      this.value.isOpen = false;
    },
  },
  destroyed() {
    this.persistData();
  },
  methods: {
    showDetail() {
      this.$emit('close-all-details', this.value);

      this.value.isOpen = !this.value.isOpen;

      if (this.value.isOpen) {
        this.setCurrentPage(1);
      }

      this.$forceUpdate();
    },
    onDetailDatarangeChanged(rangeData) {
      this.dateRangeFilter = rangeData;
      this.setCurrentPage(1);
    },
    setCurrentPage(pageNumber) {
      this.page.currentPage = pageNumber;
      this.page.data = [];

      let filteredValues = this.value.appointmentDetails.filter((x) => {
        const date = moment(x.startDate);
        let startDate = this.dateRangeFilter.startDate;
        let endDate = moment(this.dateRangeFilter.endDate)
          .set('hour', 23)
          .set('minute', 59);
        let dateIsBetween = date.isBetween(startDate, endDate, undefined, '[]');
        return dateIsBetween;
      });

      let arrayCopy = [];

      this.page.totalItemCount = filteredValues.length;

      if (this.page.totalItemCount > 0 && this.page.totalItemCount < 5) {
        this.page.count = filteredValues.length;
      } else {
        this.page.count = 5;
      }

      this.page.pageCount = Math.ceil(filteredValues.length / this.page.count);

      arrayCopy = [...filteredValues];

      if (arrayCopy.length > 0) {
        let startRowIndex =
          this.page.currentPage * this.page.count - this.page.count;

        this.page.data = arrayCopy.splice(startRowIndex, this.page.count);

        this.page.count = this.page.data.length;
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';

.col-balloon {
  min-width: 265px !important;
}
.fiscal-calendar-container,
.fiscal-calendar {
  margin: 3px;
  padding: 3px 0px;
}

.fiscal-calendar {
  background-color: map-get($colors, 'white');
  padding: 20px 30px;

  @media only screen and (max-width: 600px) {
    padding: 8px;
  }
}

.appointment-detail {
  background-color: map-get($colors, 'white');
  margin: 2px;

  & .header-row {
    margin: 5px;
    padding: 10px 0px;
  }

  & .data-row {
    margin: 5px 29px 5px 29px;
    padding: 10px 0px;
  }
}

.col-status em {
  margin-top: 5px;
  float: left;
}

.c-pictureProfile {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: #ff7058;
  display: flex;
  justify-content: center;
  align-items: center;

  em {
    position: static;
  }
}

@media only screen and (max-width: 600px) {
  .startDate {
    color: #3f5b60;
  }

  .serviceTypeName_title {
    color: #11291b !important;
    font-size: 12px !important;
    font-weight: bold !important;
  }

  .serviceTypeName_value {
    color: #11291b !important;
    font-size: 14px !important;
  }

  .schedule_title {
    color: #727272 !important;
    font-size: 12px !important;
  }

  .schedule_value {
    color: #11291b !important;
    font-size: 14px !important;
  }

  .estatus_title {
    color: #727272 !important;
    font-size: 12px !important;
    font-weight: 400 !important;
  }

  .estatus_value {
    color: #11291b !important;
    font-size: 14px !important;
  }

  .c-cardContainer {
    border: 2px solid #e2e2e2;
    overflow: hidden;
    border-radius: 5px;
  }
}

.c-cardContent {
  background-color: white;
}

@media only screen and (max-width: 600px) {
  .additionalInfo_item {
    margin-bottom: 22px;

    .additionalInfo_value {
      font-size: 14px !important;
    }
  }

  .actionButton {
    @media only screen and (max-width: 600px) {
      width: 100%;
    }
  }
}
</style>
